module.exports = __webpack_public_path__ + "img/data-item-icon.497927e4.png";